import React from 'react';
import './Access.css';

const Access: React.FC = () => {
  return (
    <div className="n-page n-access">
      <header className="n-page-header">
        <div className="container">
          <span className="n-page-eyebrow">FIND YOUR WAY</span>
          <h1>ACCESS</h1>
          <p>アクセス・店舗情報</p>
        </div>
      </header>
      <section className="n-page-body">
        <div className="n-page-content n-access-layout">
          <div className="n-access-details">
            <section className="n-access-block">
              <span className="n-page-eyebrow">STUDIO INFORMATION</span>
              <h2>店舗情報</h2>
              <dl>
                <div><dt>店舗名</dt><dd>パーソナルジムN伏見</dd></div>
                <div><dt>住所</dt><dd>〒460-0003<br />愛知県名古屋市中区錦2丁目16-1<br />アベニューフシミ1601ビル 7階</dd></div>
                <div><dt>営業時間</dt><dd>平日: 10:00 - 22:00<br />土日祝: 10:00 - 22:00</dd></div>
                <div><dt>定休日</dt><dd>年末年始</dd></div>
              </dl>
            </section>

            <section className="n-access-block n-access-routes">
              <span className="n-page-eyebrow">NEARBY STATIONS</span>
              <h2>アクセス方法</h2>
              <div className="n-route-item"><span>伏見駅 1番出口</span><strong>徒歩30秒</strong></div>
              <div className="n-route-item"><span>丸の内駅</span><strong>徒歩6分</strong></div>
            </section>
          </div>

          <div className="n-access-map">
            <iframe
              src="https://maps.google.com/maps?q=35.1700557%2C136.8976217&z=17&output=embed"
              title="パーソナルジムN伏見の地図"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
            <a
              className="n-access-map-link"
              href="https://www.google.com/maps/search/?api=1&query=35.1700557%2C136.8976217"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Mapsで経路を見る <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Access;